export const CLEAR_CACHE = 'CLEAR_CACHE';

interface ClearCacheAction {
	type: typeof CLEAR_CACHE,
}

export type GlobalApiActionTypes = ClearCacheAction;
